"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsTab = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const router_1 = require("client/components/router");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const edit_site_1 = require("../../components/edit-site");
const store_1 = require("../../store");
let DetailsTab = class DetailsTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.confirmDeleteSite = null;
        this.onCancelEditSite = () => {
            router_1.RouteManager.transitionTo("/pharmacies");
        };
        this.onSaveEditSite = async (site, enrollToErx) => {
            if (site.id) {
                await store_1.sitesDetailStore.saveSite(site);
            }
            else {
                const newSite = await store_1.sitesDetailStore.createSite(site);
                if (newSite) {
                    await store_1.sitesDetailStore.ledgerStartBalance(newSite);
                    if (enrollToErx) {
                        await store_1.sitesDetailStore.enrollToErx(newSite);
                    }
                    router_1.RouteManager.transitionTo(`/pharmacies/${newSite.id}`);
                }
            }
        };
        this.handleDeleteSite = (site) => {
            this.confirmDeleteSite = site;
        };
        this.onHandleClickConfirmDeleteSite = async () => {
            if (this.confirmDeleteSite) {
                const success = await store_1.sitesDetailStore.deleteSite(this.confirmDeleteSite);
                if (success) {
                    router_1.RouteManager.transitionTo("/pharmacies");
                }
                this.confirmDeleteSite = null;
            }
        };
        this.onHandleClickCancelDeleteSite = () => {
            this.confirmDeleteSite = null;
        };
    }
    async componentDidMount() {
        //B-051
        const siteId = Number(this.props.params[0]);
        /** Not sure why we're loading all this at once, is it in case of
         * a user switching sites with the top bar? Can we just set siteDetailsStore
         * to null on unmount?
         */
        if (siteId) {
            await store_1.sitesDetailStore.loadUsers({ allSites: true, id: siteId });
            await store_1.sitesDetailStore.loadOrders(siteId);
            await store_1.sitesDetailStore.loadPads({ id: siteId });
            // await sitesDetailStore.loadPatients({ id: siteId });
            await store_1.sitesDetailStore.loadProviders({ id: siteId });
            // await sitesDetailStore.loadEditPatients({ id: siteId });
            await store_1.sitesDetailStore.loadEditProviders({ id: siteId });
            await store_1.sitesDetailStore.readSite(siteId);
            await store_1.sitesDetailStore.readCopays(siteId);
        }
    }
    render() {
        const siteId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "sites__form" },
            React.createElement(edit_site_1.EditSite, { error: store_1.sitesDetailStore.site.error, loading: store_1.sitesDetailStore.site.loading, status: store_1.sitesDetailStore.site.status, warning: store_1.sitesDetailStore.site.value &&
                    !store_1.sitesDetailStore.site.value.picProviderId, onCancel: this.onCancelEditSite, onSave: this.onSaveEditSite, site: siteId ? store_1.sitesDetailStore.site.value : null, onDelete: this.handleDeleteSite }),
            this.confirmDeleteSite && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm and continue", cancelText: "Cancel and go back", message: `Are you sure you want to disable ${this.confirmDeleteSite.name}?`, onCancel: this.onHandleClickCancelDeleteSite, onConfirm: this.onHandleClickConfirmDeleteSite, title: "Are you sure you want to proceed?" }))));
    }
};
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "confirmDeleteSite", void 0);
DetailsTab = __decorate([
    mobx_react_1.observer
], DetailsTab);
exports.DetailsTab = DetailsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/details/details.tsx
// module id = 4016
// module chunks = 0